<div class="draggable-container" cdkDrag cdkDragBoundary=".modal" cdkDragRootElement="draggable-container">
  <div class="draggable-modal-content">
    <div class="modal-header align-items-center cursor-pointer" cdkDragHandle>
      <h6 class="modal-title modal-title-success">{{ 'Transaction Warnings' | translate }}</h6>
      <div class="warning-header-actions">
        <button *ngIf="warningPaymentIds.length"
                type="button"
                class="btn p-0 warning-header-download"
                [disabled]="isExporting"
                (mousedown)="$event.stopPropagation()"
                (click)="exportWarningTransactions()">
                <!-- [matTooltip]="'Download' | translate"
                [attr.aria-label]="'Download' | translate" -->
          <mat-icon>download</mat-icon>
        </button>
        <button type="button" class="btn-close" aria-label="'Close' | translate" (click)="close()">
          <!-- <span aria-hidden="true">&times;</span> -->
        </button>
      </div>
    </div>

    <div class="modal-body p-0">
      <div class="lms-module-card">
        <div class="card-body">
          <div class="card-form-content card-form-success">
            <div class="bg-note-info p-2 mb-3 warning-message-list" *ngIf="warningMessages.length">
              <div *ngFor="let warning of warningMessages">
                {{ warning.message }}
              </div>
            </div>
            <div class="warning-table-scroll" *ngIf="rows.length; else emptyWarnings">
            <table class="table table-align-middle mb-0 warning-table transactions-table">
              <thead class="table-header-success">
                <tr>
                  <th scope="col">{{ 'Payment ID' | translate }}</th>
                  <th scope="col">{{ 'Payment Info' | translate }}</th>
                  <th scope="col">{{ 'Effective Date' | translate }}</th>
                  <th scope="col">{{ 'Amount' | translate }}</th>
                  <th scope="col">{{ 'Method' | translate }}</th>
                  <th scope="col">{{ 'Waterfall' | translate }}</th>
                  <th scope="col">{{ 'Status' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                    <ng-container *ngFor="let row of rows; let i = index">
                        <tr [ngClass]="{
                            'table-stripped-row-dark': i%2 == 0,
                            'table-stripped-row-light': i%2 != 0
                          }">
                            <td *ngIf="checkBgResponse(row.transaction?.bg_response)">
                              <a *ngIf="paymentIdHref(row) as paymentLink; else plainPaymentId"
                                 [href]="paymentLink"
                                 target="_blank"
                                 rel="noopener"
                                 class="text-underline payment-id-link">{{row.transaction?.payment_id}}</a>
                              <ng-template #plainPaymentId>{{displayPaymentId(row.transaction)}}</ng-template>
                            </td>
                            <td *ngIf="!checkBgResponse(row.transaction?.bg_response)" style="color:red">
                              <a *ngIf="paymentIdHref(row) as paymentLink; else failedPaymentId"
                                 [href]="paymentLink"
                                 target="_blank"
                                 rel="noopener"
                                 class="text-underline payment-id-link">{{row.transaction?.payment_id}}</a>
                              <ng-template #failedPaymentId>{{displayPaymentId(row.transaction)}}</ng-template>
                            </td>
                            <td [ngClass]="{
                                'text-color': row.transaction?.payment_info_code?.code_type=='NON-CASH-SYSTEM',
                                'text-color2': row.transaction?.payment_info_code?.code_type=='NON-CASH'}">
                                <a href="javascript:void(0)" class="text-underline" (click)="toggle(i)">
{{row.transaction?.payment_info_code?.code}}</a>
                            </td>
                            <td>{{row.transaction.payment_effective_date | date: DATE_FORMAT_MMDDYYYY }}</td>
                            <td>
{{(row.transaction.payment_amount || "0.00"| currency)}}</td>
                            <td>{{row.transaction.payment_method?.source}}</td>
                            <td>{{row.transaction?.payment_waterfall_model?.code || ''}}</td>
                            <td>{{row.transaction?.payment_status}}</td>
                            </tr>
                        <tr [ngClass]="{
                            'table-stripped-row-dark': i%2 != 0,
                            'table-stripped-row-light': i%2 == 0
                          }"
                          class="payment-info" *ngIf="isExpanded(i)">
                          <!-- <img [src]="logo" class="logo"style="height: 35px; object-fit: contain; margin:10px 0;"/> -->
                            <td colspan="7">
                                <div class="row no-gutters px-2">
                                    <!-- Column 1 Payment Info -->
                                    <div class="col-lg-5 payment-info-detail">
                                        <h6>{{'Payment Info'|translate}}</h6>

                                        <div class="row">
                                            <div class="col payment-label">
                                                {{'Scheduled Payment'|translate}}:
                                            </div>
                                            <div class="col text-right">
                                                {{(row.transaction?.current_scheduled_payment || "0.00") | currency}}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col payment-label">
                                                {{'Transaction Date'|translate}}:
                                            </div>
                                            <div class="col text-right">
                                                {{ convertPstToLocalTime(row.transaction.transaction_date) | date: FULL_DATE_FORMAT
                                                }}

                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col payment-label">
                                                {{'Effective Date'|translate}}:
                                            </div>
                                            <div class="col text-right">
                                                {{row.transaction.payment_effective_date | date: DATE_FORMAT_MMDDYYYY}}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col payment-label d-flex text-nowrap">
                                                {{'Due Date'|translate}}:
                                                <mat-icon [matTooltip]="'after posting'|translate" class="info-icon">info</mat-icon>
                                            </div>
                                            <div class="col text-right">
                                                {{row.transaction.due_date | date: DATE_FORMAT_MMDDYYYY}}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col payment-label">
                                                {{'Posting Method'|translate}}:
                                            </div>
                                            <div class="col text-right">
                                                <span *ngIf="row.transaction?.posting_method=='ROLL_DUE_DATE'">{{'Rolls Due Date'|translate}} </span>
                                                <span *ngIf="row.transaction?.posting_method=='ROLL_UNTIL_CURRENT'">{{'Rolls Until Current'|translate}} </span>
                                                <span *ngIf="row.transaction?.posting_method=='DO_NOT_ROLL_DUE_DATE'">{{"Doesn't Roll Due Date"|translate}} </span>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col payment-label">
                                                {{'Source'|translate}}:
                                            </div>
                                            <div class="col text-right">
                                                {{row.transaction?.payment_method?.source}}
                                            </div>
                                        </div>
                                        <div class="row">
                                          <div class="col payment-label">
                                            {{'Pmt Received Method'|translate}}:
                                          </div>
                                          <div class="col text-right">
                                              {{(row.transaction?.payment_received_method | titleCase) | translate}}
                                          </div>
                                      </div>
                                      <div class="row">
                                        <div class="col payment-label">
                                          {{'Payment Merchant'|translate}}:
                                        </div>
                                        <div class="col text-right">
                                            <!-- {{row.transaction?.payment_merchant || 'N/A'}} -->
                                            {{row.transaction?.payment_merchant}}
                                        </div>
                                      </div>
                                        <div class="row">
                                            <div class="col payment-label text-success d-flex text-nowrap">
                                                {{'Total Amount Due'|translate}}:
                                                <mat-icon [matTooltip]="'after posting'|translate" class="info-icon">info</mat-icon>
                                            </div>
                                            <div class="col text-right">
                                                <span class="text-success">
{{(row.transaction.total_amount_due || "0.00"| currency)}}</span>
                                            </div>
                                        </div>
                                      <!------For Blank Row------>
                                      <div style="height:10px;"></div>
                                      <!------For End Blank Row------>
                                        <div class="row">
                                          <div class="col payment-label">
                                              {{'Created By'|translate}}:
                                          </div>
                                          <div class="col text-right" *ngIf="row.transaction?.created_by!=null">
                                              {{row.transaction?.created_by?.employee_initials}} <span class="word-break">
                                                  {{row.transaction?.created_by?.firstname}} {{row.transaction?.created_by?.lastname}}</span>
                                          </div>
                                          <div class="col text-right" *ngIf="row.transaction?.created_by==null">
                                            {{'SYS System'|translate}}
                                          </div>

                                          <!-- <div class="col text-right" *ngIf="row.transaction?.updated_by==null">
                                            SYS <span class="text-success">
                                              System </span>
                                          </div> -->
                                      </div>
                                      <div class="row">
                                        <div class="col payment-label">
                                            {{'Updated By'|translate}}:
                                        </div>
                                        <div class="col text-right" *ngIf="row.transaction?.updated_by!=null">
                                            {{row.transaction?.updated_by?.employee_initials}} <span class="word-break">
                                                {{row.transaction?.updated_by?.firstname}} {{row.transaction?.updated_by?.lastname}}</span>
                                        </div>
                                        <div class="col text-right" *ngIf="row.transaction?.updated_by==null">
                                          {{'SYS System'|translate}}
                                        </div>

                                        <!-- <div class="col text-right" *ngIf="row.transaction?.updated_by==null">
                                          SYS <span class="text-success">
                                            System </span>
                                        </div> -->
                                        </div>
                                    <div class="row">
                                      <div class="col payment-label">
                                        {{'Transaction Agent'|translate}}:
                                      </div>
                                      <div class="col text-right" *ngIf="row.transaction?.transaction_agent!=null">
                                        {{row.transaction?.transaction_agent?.employee_initials}} <span class="word-break">
                                          {{row.transaction?.transaction_agent?.firstname}} {{row.transaction?.transaction_agent?.lastname}}</span>
                                      </div>

                                      <div class="col text-right" *ngIf="row.transaction?.transaction_agent==null">

                                        <span class="word-break">
                                          {{row.transaction?.transaction_agent_full_name}}
                                        </span>
                                      </div>

                                      </div>
                                    </div>
                                    <!-- Remaining Balance -->
                                    <div *ngIf="!printing" class="col-lg-7 payment-info-detail remaining-balance-overflow">
                                        <!-- <div class="row">
                                          <div class="col payment-label text-success">
                                             &nbsp;
                                            </div>
                                            <div class="col text-right">
                                            &nbsp;
                                            </div>
                                        </div> -->
                                        <table class="table table-sm table-no-bg table-align-middle mb-0 remaining-balance-wrapper full-width">

                                          <tr>
                                            <td class="rm-width">
                                                  <h6>{{'Remaining Balance'|translate}}</h6>
                                            </td>
                                            <td class="text-right">
                                              <span title="Previous Transaction Balance">
                                                {{'Prev'|translate}}
                                              </span>
                                            </td>
                                            <td class="text-right minw-10">
                                            </td>
                                            <td class="text-right">
                                              <span title="Current Transaction Balance">
                                                  {{'Curr'|translate}}
                                              </span>
                                            </td>
                                        </tr>

                                          <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        {{'Principal'|translate}}:
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{(row.transaction?.previous_transaction?.remaining_principal_balance||"0.00" | currency)}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_principal_balance')">
                                                        {{(row.transaction?.remaining_principal_balance||"0.00" | currency)}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        {{'Interest'|translate}}:
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{(row.transaction?.previous_transaction?.remaining_interest_balance||"0.00" | currency)}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_interest_balance')">
                                                        {{(row.transaction?.remaining_interest_balance|| "0.00" | currency)}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        {{'Late Fees'|translate}}:
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{(row.transaction?.previous_transaction?.remaining_late_fees_balance||"0.00" | currency)}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_late_fees_balance')">
                                                        {{(row.transaction?.remaining_late_fees_balance|| "0.00" | currency)}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        {{'NSF Fees'|translate}}:
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{(row.transaction?.previous_transaction?.remaining_nsf_fees_balance||"0.00" | currency)}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_nsf_fees_balance')">
                                                        {{(row.transaction?.remaining_nsf_fees_balance|| "0.00" | currency)}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        {{'Other Fees'|translate}}:
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{(row.transaction?.previous_transaction?.remaining_other_fees_balance||"0.00" | currency)}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_other_fees_balance')">
                                                        {{(row.transaction?.remaining_other_fees_balance||"0.00" | currency)}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        {{'Sales Tax'|translate}}:
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{(row.transaction?.previous_transaction?.remaining_tax_balance ||"0.00" | currency)}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_tax_balance')">
                                                        {{(row.transaction?.remaining_tax_balance ||"0.00" | currency)}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        {{"CPI Fees"|translate}}:
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{(row.transaction?.previous_side_note_payments?.remaining_cpi_balance ||"0.00" | currency)}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_cpi_balance')">
                                                        {{(row.transaction?.side_note_payments?.remaining_cpi_balance ||"0.00" | currency)}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        {{"Side Note 1 Fees"|translate}}:
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{(row.transaction?.previous_side_note_payments?.remaining_side_note_1_balance ||"0.00" | currency)}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_side_note_1_balance')">
                                                        {{(row.transaction?.side_note_payments?.remaining_side_note_1_balance ||"0.00" | currency)}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        {{"Side Note 2 Fees"|translate}}:
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{(row.transaction?.previous_side_note_payments?.remaining_side_note_2_balance ||"0.00" | currency)}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_side_note_2_balance')">
                                                        {{(row.transaction?.side_note_payments?.remaining_side_note_2_balance ||"0.00" | currency)}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        {{"Side Note 3 Fees"|translate}}:
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{(row.transaction?.previous_side_note_payments?.remaining_side_note_3_balance ||"0.00" | currency)}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_side_note_3_balance')">
                                                        {{(row.transaction?.side_note_payments?.remaining_side_note_3_balance ||"0.00" | currency)}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        {{"Side Note 4 Fees"|translate}}:
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{(row.transaction?.previous_side_note_payments?.remaining_side_note_4_balance ||"0.00" | currency)}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_side_note_4_balance')">
                                                        {{(row.transaction?.side_note_payments?.remaining_side_note_4_balance ||"0.00" | currency)}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        {{"Side Note 5 Fees"|translate}}:
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{(row.transaction?.previous_side_note_payments?.remaining_side_note_5_balance ||"0.00" | currency)}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_side_note_5_balance')">
                                                        {{(row.transaction?.side_note_payments?.remaining_side_note_5_balance ||"0.00" | currency)}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        {{"Down Payment"|translate}}:
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{(row.transaction?.previous_transaction?.remaining_down_payment_balance ||"0.00" | currency)}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_down_payment_balance')">
                                                        {{(row.transaction?.remaining_down_payment_balance ||"0.00" | currency)}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label text-success">
                                                        {{'Total'|translate}}:
                                                    </div>
                                                </td>
                                                <td class="text-right"></td>
                                                <td></td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple">
                                                        <span class="text-success">
{{(row.transaction?.remaining_total_balance|| "0.00" | currency)}}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="5">
                                                    <div class="border-top m-2"></div>
                                                </td>
                                            </tr>
                                            <!-- <tr class="">
                                                <td></td>
                                                <td class="text-right">Previous</td>
                                                <td></td>
                                                <td class="text-right">Current</td>
                                            </tr> -->
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        {{'Due Date'|translate}}
                                                    </div>
                                                </td>
                                                <td class="text-right">{{row.transaction?.previous_transaction?.due_date | date: DATE_FORMAT_MMDDYYYY}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple">
                                                        {{row.transaction?.due_date | date: DATE_FORMAT_MMDDYYYY}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        {{"DPD"|translate}}
                                                    </div>
                                                </td>
                                                <td class="text-right">{{row.transaction?.previous_transaction?.dpd ||"0" }}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple">
                                                        {{row.transaction?.dpd ||"0"}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        {{'Min Amount to Roll'|translate}}
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{row.transaction?.previous_transaction?.remaining_min_amount_to_roll|| "0.00" | currency }}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple">
                                                        {{row.transaction?.remaining_min_amount_to_roll|| "0.00" | currency}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <!-- <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        Days Past Due
                                                    </div>
                                                </td>
                                                <td class="text-right">{{ row.transaction?.previous_transaction?.past_due != null ? row.transaction?.previous_transaction?.past_due : '-'  }}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple">
                                                        {{row.transaction?.past_due != null ? row.transaction?.past_due : '-'}}
                                                    </div>
                                                </td>
                                            </tr> -->
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                        {{'Amount Due'|translate}}
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{row.transaction?.previous_transaction?.remaining_amount_due|| "0.00"  | currency}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple">
                                                        {{row.transaction?.remaining_amount_due|| "0.00"  | currency}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="w-25">
                                                    <span class="l-image-block d-inline-block px-1"> <img src="assets/images/icons/L_img.png" alt="" class="img-fluid icon-dark"></span>
                                                    <span>{{'Plus Suspense'|translate}}</span>
                                                </td>
                                                <td class="text-right">
{{row.transaction?.previous_transaction?.remaining_amount_due_plus_sus|| "0.00"  | currency}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple">
                                                      {{row.transaction?.remaining_amount_due_plus_sus|| "0.00"  | currency}}
                                                    </div>
                                                </td>
                                            </tr>
                                            
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                       {{"CPI Amount Due"|translate}}
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{addVariables(row.transaction?.previous_side_note_payments?.cpi_amount_due ) || "0.00"  | currency}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple">
                                                      {{addVariables( row.transaction?.side_note_payments?.cpi_amount_due)|| "0.00"  | currency}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label custom-payment-label">
                                                       {{"Side Note 1 Amount Due"|translate}}
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{row.transaction?.previous_side_note_payments?.side_note_1_amount_due|| "0.00"  | currency}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple">
                                                      {{row.transaction?.side_note_payments?.side_note_1_amount_due|| "0.00"  | currency}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label custom-payment-label">
                                                        {{"Side Note 2 Amount Due"|translate}}
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{row.transaction?.previous_side_note_payments?.side_note_2_amount_due|| "0.00"  | currency}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple">
                                                      {{row.transaction?.side_note_payments?.side_note_2_amount_due|| "0.00"  | currency}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label custom-payment-label">
                                                        {{"Side Note 3 Amount Due"|translate}}
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{row.transaction?.previous_side_note_payments?.side_note_3_amount_due|| "0.00"  | currency}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple">
                                                      {{row.transaction?.side_note_payments?.side_note_3_amount_due|| "0.00"  | currency}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label custom-payment-label">
                                                        {{"Side Note 4 Amount Due"|translate}}
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{row.transaction?.previous_side_note_payments?.side_note_4_amount_due|| "0.00"  | currency}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple">
                                                      {{row.transaction?.side_note_payments?.side_note_4_amount_due|| "0.00"  | currency}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label custom-payment-label">
                                                        {{"Side Note 5 Amount Due"|translate}}
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{row.transaction?.previous_side_note_payments?.side_note_5_amount_due|| "0.00"  | currency}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple">
                                                      {{row.transaction?.side_note_payments?.side_note_5_amount_due|| "0.00"  | currency}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="payment-label">
                                                       {{'Total Amount Due'|translate}}
                                                    </div>
                                                </td>
                                                <td class="text-right">
{{row.transaction?.previous_transaction?.total_amount_due|| "0.00"  | currency}}</td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple">
                                                      {{row.transaction?.total_amount_due|| "0.00"  | currency}}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="">
                                                    <span class="l-image-block d-inline-block px-1"><img src="assets/images/icons/L_img.png" alt="" class="img-fluid icon-dark"></span>
                                                    <span> {{'Plus Suspense'|translate}}</span>
                                                </td>
                                                <td class="text-right">
                                                  {{ (row.transaction?.previous_transaction?.total_amount_due ?? 0) + (row.transaction?.previous_transaction?.remaining_suspence_balance ?? 0)  | currency}}
                                                </td>
                                                <td class="text-right">
                                                    <img src="assets/images/icons/arrow2-transparent.png" alt="" class="img-fluid icon-dark">
                                                    <img src="assets/images/icons/arrow2-light.png" class="img-fluid icon-light">
                                                </td>
                                                <td>
                                                    <div class="text-right lms-text-light-purple">
                                                      {{ (row.transaction?.total_amount_due ?? 0) + (row.transaction?.remaining_suspence_balance ?? 0) | currency }}
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                    <!-- <div *ngIf="!printing" class="col-lg-3 payment-info-detail">
                                        <h6>Current Balance</h6>
                                        <div class="row">
                                          <div class="col payment-label text-success">
                                             &nbsp;
                                        </div>
                                        <div class="col text-right">
                                          &nbsp;
                                        </div>
                                        </div>
                                        <div class="row">
                                            <div class="col payment-label">
                                                Principal:
                                            </div>
                                            <div class="col text-right" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_principal_balance')">
                                                {{(row.transaction?.remaining_principal_balance||"0.00" | currency)}}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col payment-label">
                                                Interest:
                                            </div>
                                            <div class="col text-right" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_interest_balance')">
                                                {{(row.transaction?.remaining_interest_balance|| "0.00" | currency)}}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col payment-label">
                                                Late Fees:
                                            </div>
                                            <div class="col text-right" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_late_fees_balance')">
                                                {{(row.transaction?.remaining_late_fees_balance|| "0.00" | currency)}}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col payment-label">
                                                NSF Fees:
                                            </div>
                                            <div class="col text-right" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_nsf_fees_balance')">
                                                {{(row.transaction?.remaining_nsf_fees_balance|| "0.00" | currency)}}
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col payment-label">
                                                Other Fees:
                                            </div>
                                            <div class="col text-right" [class.warning-negative-value]="isNegativeBalanceAmount(row, 'remaining_other_fees_balance')">
                                                {{(row.transaction?.remaining_other_fees_balance||"0.00" | currency)}}
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col payment-label text-success">
                                                Total:
                                            </div>
                                            <div class="col text-right">
                                                <span class="text-success">
{{(row.transaction?.remaining_total_balance|| "0.00" | currency)}}</span>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                                <div class="row no-gutters px-2">
                                    <div class="payment-label reference-note">
                                        {{'Reference Note'|translate}}:
                                    </div>
                                    <div class="text-right pl-1">
                                        <span >{{(row.transaction?.reference_note|| " " )}}</span>
                                    </div>
                                </div>
                                <div *ngIf="!checkBgResponse(row.transaction?.bg_response)" class="row no-gutters" style="color: red">
                                    <div class="payment-label reference-note">
                                        <span >Error: {{jsonParse(row.transaction?.bg_response) || errorText }}</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
          <ng-template #emptyWarnings>
            <div class="py-3 text-center" *ngIf="!warningMessages.length">{{ 'There are no warnings.' | translate }}</div>
          </ng-template>
          <div class="mt-3 warning-export-note" *ngIf="warningPaymentIds.length">
            {{ 'Note: Before acknowledging this warning, we recommend downloading and securely saving the affected transaction data using the ' | translate }}<a href="javascript:void(0)"
               class="text-underline export-link"
               [class.disabled]="isExporting"
               (click)="exportWarningTransactions()">{{ 'Download' | translate }}</a>{{ ' option. This will allow you to refer to the data in the future, if needed. Once the warning is acknowledged, it will no longer be visible.' | translate }}
          </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer justify-content-between align-items-center">
      <label class="warning-review-confirm mb-0" for="reviewWarningCheck">
        <input id="reviewWarningCheck" type="checkbox"
          [checked]="confirmReview" (change)="confirmReview = $any($event.target).checked">
        <span class="font-size-14 text-yellow">
          {{ 'Mark this as reviewed and do not show the warning again.' | translate }}
        </span>
      </label>
      <button type="button" class="btn btn-success-light btn-150" [disabled]="!confirmReview || isReviewing" (click)="markReviewed()">
        {{ 'Submit' | translate }}
      </button>
    </div>
  </div>
</div>
